import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import {
  Button,
  Row,
  Col,
  Input,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  EditorState,
  RichUtils,
  convertFromHTML,
  ContentState,
  KeyBindingUtil,
  Modifier,
  convertToRaw,
  convertFromRaw,
  ContentBlock,
  genKey,
  SelectionState,
} from 'draft-js';
import 'draft-js/dist/Draft.css';
import Editor from "draft-js-plugins-editor"
import createHighlightPluginOk from './editor_plugins/highlightPluginOk'
import createHighlightPluginNotOk from './editor_plugins/highlightPluginNotOk'
import createHighlightPluginNotDict from './editor_plugins/highlightPluginDict'
import addLinkPlugin from './editor_plugins/addLinkPlugin'
import BlockStyleToolbar, { getBlockStyle } from "./editor_block_styles/BlockStyleToolbar"
import { stateToHTML } from 'draft-js-export-html';
import { isMobile } from 'react-device-detect';

const Diff = require('diff');

// constants
const highlightPluginOk = createHighlightPluginOk();
const highlightPluginNotOk = createHighlightPluginNotOk();
const highlightPluginDict = createHighlightPluginNotDict();

// DemoEditor
// const DemoEditor = (props) => {
const DemoEditor = forwardRef((props, ref) => {

  useImperativeHandle(ref, () => ({

    getBlocks() {
      let rawData = convertToRaw(editorState.getCurrentContent())
      return rawData.blocks
    }

  }));

  // use history
  let navigate = useNavigate()
  let dispatch = useDispatch();

  let [editorState, setEditorState] = useState(
    () => EditorState.createEmpty(),
  );
  let [plugins, setPlugins] = useState([highlightPluginOk, highlightPluginDict, highlightPluginNotOk])
  let [lastKey1, setLastKey1] = useState("")
  let [top, setTop] = useState(0)
  let [left, setLeft] = useState(0)
  // let [showTooltip, setShowTooltip] = useState(false)
  let [healthScore, setHealthScore] = useState(-1)
  //
  // let [removed , setRemoved] = useState("")
  // let [added , setAdded] = useState("")
  let [replacedList, setReplacedList] = useState([])
  let [lastAddOrRemove, setLastAddOrRemove] = useState("")

  let [hiragana, setHiragana] = useState("")
  // let [kanji, setKanji] = useState("")
  let [wordCategory, setWordCategory] = useState("")

  let [demoMode, setDemoMode] = useState("wait")

  // componentDidMount
  useEffect(() => {

    if (props.transcriptDraftjsRaw) {

      if (props.transcriptDraftjsRaw.blocks.length === 0) {
        return;
      }

      let state = convertFromRaw(props.transcriptDraftjsRaw);
      setEditorState(EditorState.createWithContent(state))

      setDemoMode("edit")
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.transcriptDraftjsRaw, props.mojiokoCount]);

  /// draft.js rich editor

  // _handleKeyCommand
  let _handleKeyCommand = (command, editorState) => {

    const newState = RichUtils.handleKeyCommand(editorState, command);

    if (newState) {
      setEditorState(newState);
      return 'handled';
    }

    return 'not-handled';
  }

  // https://github.com/facebook/draft-js/blob/010fce785948edaf92bd9e81e8777784c1421545/src/model/immutable/SampleDraftInlineStyle.js
  let _onBoldClick = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'BOLD'))
  }

  // _onHighlight
  let _onHighlight = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT'))
  }

  let _onAddLink = () => {

    const selection = editorState.getSelection();
    const link = window.prompt('Paste the link -')
    if (!link) {
      setEditorState(RichUtils.toggleLink(editorState, selection, null));
      return 'handled';
    }
    const content = editorState.getCurrentContent();
    const contentWithEntity = content.createEntity('LINK', 'MUTABLE', { url: link });
    const newEditorState = EditorState.push(editorState, contentWithEntity, 'create-entity');
    const entityKey = contentWithEntity.getLastCreatedEntityKey();
    setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey))
  }

  // _toggleBlockType
  let _toggleBlockType = blockType => {
    setEditorState(RichUtils.toggleBlockType(editorState, blockType));
  };

  // VERY HARD
  // editor _onChange events
  let _onChange = (newState) => {

    // current content block state
    let content_old = editorState.getCurrentContent()
    // upcoming content block state
    let content_new = newState.getCurrentContent()

    // this parameter keep returning same if contet not changed
    let _lastType = newState.getLastChangeType()

    // check content has changed or not
    if (content_old === content_new) {

      // same
      setEditorState(newState)
      return;
    }

    // old selection state
    let selection_state_old = content_new.selectionBefore
    // old selection anchor offset
    let anchor_offset_old = selection_state_old.getAnchorOffset()

    // new selection state
    let selection_state_new = content_new.selectionAfter
    // new selection achor offset
    let anchor_offset_new = selection_state_new.getAnchorOffset()

    // block key of old selection state
    let block_key_old = content_new.selectionBefore.getStartKey()
    // block key of new selection state
    let block_key_new = content_new.selectionAfter.getStartKey()

    // new content block
    let block_new = content_new.getBlockForKey(block_key_new)
    // data of new content block
    let block_new_data = block_new.getData().toObject()
    let time0_new = ""
    if ( block_new_data["time0"] ) {
      time0_new = block_new_data["time0"]
    }

    // this is actually last time key
    // 0~4@0-10___4~7@10-14 > "4~7"
    let time_key_new = ""
    if (time0_new) {

      // get last one
      let arr0 = time0_new.split("___")
      let timedata_last = arr0[arr0.length-1]

      time_key_new = timedata_last.split("@")[0]
    }
    let block_new_length = block_new.getLength()

    // get old data which was combined and deleted
    let block_old = content_old.getBlockForKey(block_key_old)
    // let block_old_data = block_old.getData().toObject()
    let block_old_data = {}
    let block_old_length = -1
    if (block_old) {
      if (block_old.getData()) {
        block_old_data = block_old.getData().toObject()
      }
      block_old_length = block_old.getLength()
    }
    // let block_old_data = block_old.getData().toObject()
    // let block_old_length = block_old.getLength()
    let time0_old = ""
    if ( block_old_data["time0"] ) {
      time0_old = block_old_data["time0"]
    }

    // this is actually first time key
    // 8~12@0-10___12~9@10-14 > "8~12"
    let time_key_old = ""
    if (time0_old) {

      // get last one
      let arr0 = time0_old.split("___")
      // let timedata_last = arr0[arr0.length-1]
      let timedata_last = arr0[0]

      time_key_old = timedata_last.split("@")[0]
    }

    // split block
    if ( _lastType === "split-block" ) {

      // console.log("======= split block =======")

      // prepare block data for newly created content block data
      let block_data_new = {}
      if (time0_old) {

        // get last one
        let arr0 = time0_old.split("___")

        // console.log("こっちが下の行なの？？？")

        let _time07_all = ""

        for (let i=0; i<arr0.length; i++) {
          let _key07 =  arr0[i].split("@")[0]
          let _range07 =  arr0[i].split("@")[1]
          let _offset07 = parseInt(_range07.split("-")[0])
          let _length07 = parseInt(_range07.split("-")[1])

          let _offset_of_linex_0 = block_old_length - block_new_length

          if (_offset_of_linex_0 === 0) {
            // 行頭で改行がなされた！

            _time07_all = time0_old

          } else {

            let _end_offset_07 = _offset07 + _length07

            if (_end_offset_07 <= _offset_of_linex_0 ) {
              continue
            }

            if ( _offset07 < _offset_of_linex_0 ) {

              // console.log("1. _key07: ", _key07)

              let _offset077 = 0
              let _length077 = _length07 - _offset_of_linex_0

              // console.log("_offset077: ", _offset077)
              // console.log("_length077: ", _length077)

              let _time07 = _key07+"@"+_offset077+"-"+_length077
              _time07_all = _time07_all + _time07 + "___"

            } else {

              // console.log("2. _key07: ", _key07)

              let _offset077 = _offset07 - _offset_of_linex_0

              let _time07 = _key07+"@"+_offset077+"-"+_length07
              _time07_all = _time07_all + _time07 + "___"
            }
          }
        }
        if (_time07_all.endsWith("___") === true) {
          _time07_all = _time07_all.substr(0, _time07_all.length-3)
        }
        // console.log("_time07_all: ", _time07_all)

        let timedata_last = arr0[arr0.length-1]

        // split time key and offsets
        let _time_key =  timedata_last.split("@")[0]

        // console.log("_time07_all: ", _time07_all)

        let _end_2 = block_new_length
        if (_end_2 < 1) {

          // console.log("aaa 1")

          let _time_range =  _time07_all.split("@")[0]
          let _start = parseFloat(_time_range.split("~")[0])

          _end_2 = 0
          _time_key = "dummy"+_start
        }

        if ( !block_new || !block_new.text ) {

          _time_key = "dummy"
        }

        let _time00 = _time_key + "@" + "0-"+_end_2

        if (_time_key !== "dummy") {
          _time00 = _time07_all
        }

        block_data_new = {
          'time0': _time00,
        }
      }

      // update newly created block
      // let selection_state1 = SelectionState.createEmpty(block_key_new)
      let selection_state1 = newState.getSelection()

      let new_state1 = Modifier.setBlockData(
        content_new,
        selection_state1,
        block_data_new,
      )

      // push
      let editor_state31 = EditorState.push(
        newState,
        new_state1,
        'fix-data' // サンプルをコピーしたが、 EditorChangeType に従ってないからダメなのかも
      )

      // update old trimmed old block
      let block_data_old2 = {}

      if (time0_old) {

        // console.log("？？？こっちが上の行なの／")

        // get last one
        let arr0 = time0_old.split("___")

        let _time07_all = ""

        for (let i=0; i<arr0.length; i++) {
          let _key07 =  arr0[i].split("@")[0]
          let _range07 =  arr0[i].split("@")[1]
          let _offset07 = parseInt(_range07.split("-")[0])
          let _length07 = parseInt(_range07.split("-")[1])
          // console.log("_offset07: ", _offset07)
          // console.log("_length07: ", _length07)
          // console.log("block_old_length: ", block_old_length)
          // console.log("block_new_length: ", block_new_length)
          // console.log("arr0[i] < _key07: ", arr0[i])

          let _offset_of_linex_0 = block_old_length - block_new_length

          if (_offset_of_linex_0 === 0) {
            // 行頭で改行がなされた！
            // console.log("行頭で改行がなされた！")
            // _time07_all = time0_old

          } else {

            let _end_offset_07 = _offset07 + _length07

            if (_offset07 >= _offset_of_linex_0 ) {
              continue
            }

            if ( _end_offset_07 < _offset_of_linex_0 ) {

              // console.log("11. _key07: ", _key07)

              let _time07 = _key07+"@"+_range07
              _time07_all = _time07_all + _time07 + "___"

            } else {

              // console.log("2. _key07: ", _key07)

              let _length077 = _offset_of_linex_0 -_offset07

              let _time07 = _key07+"@"+_offset07+"-"+_length077
              _time07_all = _time07_all + _time07 + "___"
            }
          }

        }
        if (_time07_all.endsWith("___") === true) {
          _time07_all = _time07_all.substr(0, _time07_all.length-3)
        }
        // console.log("_time07_all: ", _time07_all)

        let _time_key = ""

        let _end_2 = block_old_length - block_new_length

        if (_end_2 < 1) {
          _end_2 = 0
          _time_key = "dummy"
        }

        if ( !block_old || !block_old.text ) {
          _time_key = "dummy"
        }

        if (!_time07_all) {
          _time_key = "dummy"
        }

        let _time00 = ""
        if (_time_key === "dummy") {
          _time00 = "dummy@0-0"
        } else {
          _time00 = _time07_all
        }

        block_data_old2 = {
          'time0': _time00,
        }
      }

      let editor_state2 = EditorState.createWithContent(new_state1)
      let selection_state2 = editor_state2.getSelection()

      let selection_state_tmp = SelectionState.createEmpty(block_key_old)

      let new_content_state2 = Modifier.setBlockData(
        new_state1,
        selection_state_tmp,
        block_data_old2,
      )

      let editor_state3 = EditorState.push(
        editor_state2,
        new_content_state2,
        'handle_split_block',
      )

      // update state here actually.
      // setEditorState(editor_state3)
      setEditorState(EditorState.forceSelection(editor_state3, selection_state1))
      return
    }


    if (block_key_old !== block_key_new) {

      // new block is created or one block is deleted
      // console.log("======= block is deleted or combined =======")

      if (time_key_new !== "") {

        if (time_key_new !== time_key_old) {

          // let
          let time0_new_new = ""
          if (time0_new !== "dummy@0-0") {
            time0_new_new = time0_new
          }
          let arr0 = time0_old.split("___")
          for ( let i=0; i<arr0.length; i++ ) {

            let _str0 = arr0[i]
            if (_str0 === "dummy@0-0") {
              continue
            }

            let _key0 = _str0.split("@")[0]
            let _range0 = _str0.split("@")[1]
            let _start0 = parseInt(_range0.split("-")[0])
            let _length0 = parseInt(_range0.split("-")[1])

            // console.log("_range0: ", _range0)
            //
            // console.log("_start0: ", _start0)
            // console.log("block_old_length: ", block_old_length)
            // console.log("block_new_length: ", block_new_length)
            let _start00 = _start0 + block_old_length

            if (time0_new_new) {

              if (_range0 === "0-0") {
                // we want to update timestamps of past record

                let _arr00 = time0_new_new.split("___")
                let time0_new_new_00 = ""
                for (let j=0; j<_arr00.length; j++) {
                  let _itme00 = _arr00[j]
                  if (j !== _arr00.length -1){
                    time0_new_new_00 = time0_new_new_00 + _itme00
                  } else {
                    let _key000 = _itme00.split("@")[0]
                    let _start000 = parseFloat(_key000.split("~")[0])
                    // let _end000 = parseFloat(_key000.splity("~")[1])
                    let _end001 =  parseFloat(_key0.split("~")[1])
                    let _range000 = _itme00.split("@")[1]
                    // let _start000 = parseInt(_range000.split("-")[0])
                    // let _length000 = parseInt(_range000.split("-")[1])

                    let _itme01 = _start000+"~"+_end001+"@"+_range000

                    time0_new_new_00 = time0_new_new_00 + _itme01
                  }
                }

                // console.log("======>>>>>>")
                time0_new_new = time0_new_new_00
                // console.log("time0_new_new_00: ", time0_new_new_00)
                // console.log("======>>>>>>")

              } else {

                // console.log("koko 1")

                // get last offset
                let _arr00 = time0_new_new.split("___")

                let _last_range00 = _arr00[_arr00.length-1].split("@")[1].trim()

                // console.log("_last_range00: ", _last_range00, _last_range00.length, typeof _last_range00)


                // WTF string.spilt is not a function ???
                let _mode = "first"
                let _last_offset00 = ""
                let _last_length00 = ""
                for (let j=0; j<_last_range00.length; j++) {
                  let _char = _last_range00[j]
                  if (_char === "-") {
                    _mode = "second"
                    continue
                  }
                  if (_mode === "first") {
                    _last_offset00 = _last_offset00 + _char
                  } else if (_mode === "second") {
                    _last_length00 = _last_length00 + _char
                  }
                }
                // let _last_offset00 = _last_range00.spilt("-")[0]
                // let _last_length00 = _last_range00.spilt("-")[1]

                _last_offset00 = parseInt(_last_offset00)
                _last_length00 = parseInt(_last_length00)

                // console.log("_last_offset00: ", _last_offset00)
                // console.log("_last_length00: ", _last_length00)

                let _start02 = _last_offset00 + _last_length00

                time0_new_new = time0_new_new+"___"+time_key_old+"@"+_start02+"-"+_length0
              }

            } else {

              // console.log("koko 2")
              // time0_new_new = time_key_old+"@"+_start00+"-"+_length0

              // 空文字列に文字列を追加した時に呼ばれる？
              let block_text_new = block_new.getText()
              time0_new_new = "dummy@0-"+block_text_new.length

            }
          }
          // console.log("time0_new_new: ", time0_new_new)

          let _bk = {
            'time0': time0_new_new
          }

          // update newly combined block
          // let selectionState3 = SelectionState.createEmpty(block_key_new)
          let selection_satete = newState.getSelection()
          let contentWithoutDash3 = Modifier.setBlockData(
            content_new,
            selection_satete,
            _bk,
          )

          let selectionState1 = newState.getSelection();
          let anchorKey1 = selectionState1.getAnchorKey();
          let currentContent1 = newState.getCurrentContent();
          let currentContentBlock = currentContent1.getBlockForKey(anchorKey1);
          let start1 = selectionState1.getStartOffset();
          let end1 = selectionState1.getEndOffset();
          let selectedText1 = currentContentBlock.getText().slice(start1, end1);

          // var selectionState = SelectionState.createEmpty('blockkey');
          var updatedSelectionState = selection_satete.merge({
            focusOffset: anchor_offset_new,
            anchorOffset: anchor_offset_new,
          });


          let newState3 = EditorState.push(
            newState,
            contentWithoutDash3,
            'add-data' // サンプルをコピーしたが、 EditorChangeType に従ってないからダメなのかも
          )
          // setEditorState(newState3)
          setEditorState(EditorState.forceSelection(newState3, updatedSelectionState))

          return;

        } else {

          // 2 blocks with same key is combined!
          // backspace

          let time0_new_2 = ""
          if (time0_new) {

            // loop for all time data
            let arr0 = time0_new.split("___")

            // let time0_new_2 = ""
            for (let i=0; i<arr0.length; i++) {
              let _timedata = arr0[i]

              if (i !== arr0.length - 1) {
                time0_new_2 = time0_new_2 + _timedata + "___"
              } else {
                // last one
                let _time_key_last = _timedata.split("@")[0]
                let _offsets_last = _timedata.split("@")[1]
                let _start = _offsets_last.split("-")[0]
                let _end = _offsets_last.split("-")[1]
                // let _end2 = block_new_length - 1
                let _end2 = block_new_length

                let _timedata_2 = _time_key_last+"@"+_start+"-"+_end2
                time0_new_2 = time0_new_2 + _timedata_2
              }
            }
          }

          // data of block content
          let _bk = {
            'time0': time0_new_2
          }

          // update newly combined block
          // let selectionState3 = SelectionState.createEmpty(block_key_new)
          let selection_satete = newState.getSelection()

          let selectionState1 = newState.getSelection();
          let anchorKey1 = selectionState1.getAnchorKey();
          let currentContent1 = newState.getCurrentContent();
          let currentContentBlock = currentContent1.getBlockForKey(anchorKey1);
          let start1 = selectionState1.getStartOffset();
          let end1 = selectionState1.getEndOffset();
          let selectedText1 = currentContentBlock.getText().slice(start1, end1);

          // var selectionState = SelectionState.createEmpty('blockkey');
          var updatedSelectionState = selection_satete.merge({
            focusOffset: anchor_offset_new,
            anchorOffset: anchor_offset_new,
          });


          let contentWithoutDash3 = Modifier.setBlockData(
            content_new,
            updatedSelectionState,
            _bk,
          )

          // let contentWithoutDash3 = Modifier.setBlockData(
          //   content_new,
          //   selection_satete,
          //   _bk,
          // )

          let newState3 = EditorState.push(
            newState,
            contentWithoutDash3,
            'add-data' // サンプルをコピーしたが、 EditorChangeType に従ってないからダメなのかも
          )
          // setEditorState(newState3)
          setEditorState(EditorState.forceSelection(newState3, updatedSelectionState))

          // console.log("=========== backspace =========")

          return;
        }
      }

    } else {

      // old and new  block key is same
      // console.log("koko ??? 000 ")

      // content_current > content_old
      let content_old = editorState.getCurrentContent()
      let content_new = newState.getCurrentContent()
      let content_old_raw = convertToRaw(content_old)
      let content_new_raw = convertToRaw(content_new)

      if (content_old_raw.blocks.length -1 === content_new_raw.blocks.length){

        // console.log("koko ??? 00 ")

        let content_old_block_keys = []
        for ( let j=0; j<content_old_raw.blocks.length; j++ ) {
          let _item = content_old_raw.blocks[j]
          content_old_block_keys.push(_item.key)
        }

        let content_new_block_keys = []
        for ( let j=0; j<content_new_raw.blocks.length; j++ ) {
          let _item = content_new_raw.blocks[j]
          content_new_block_keys.push(_item.key)
        }

        let _removedKey = ""
        for (let j=0; j<content_old_block_keys.length; j++) {
          let _key = content_old_block_keys[j]
          if ( content_new_block_keys.indexOf(_key) === -1 ) {
            _removedKey = _key
          }
        }
        // console.log("removed key : ", _removedKey)
        // _removedKey からオリジナルのテキストは抽出可能
        // 元々のテキストも抽出可能

        // 削除された行の元々のテキスト
        let deleted_block = content_old.getBlockForKey(_removedKey);
        let deleted_text = deleted_block.getText()
        // console.log("deleted_text: ", deleted_text)
        // 操作前の0行めのテキスト
        let old_original_block = content_old.getBlockForKey(block_key_new);
        let old_original_text = old_original_block.getText()
        // console.log("old_original_text: ",old_original_text)


        // block_text_new
        let block_text_new = block_new.getText()
        // console.log("block_text_new: ",block_text_new)
        // console.log("==== select and delete and blocks combines. ==== ")

        // actutlly we need it
        let _text0 = _diff_remain_parts(block_text_new, old_original_text)
        // console.log("block_text_new: ", block_text_new)
        // console.log("old_original_text: ", old_original_text)
        // console.log("_text0: ", _text0)
        // console.log("")

        let _text1 = _diff_remain_parts(block_text_new, deleted_text)
        // console.log("block_text_new: ", block_text_new)
        // console.log("deleted_text: ", deleted_text)
        // console.log("_text1: ", _text1)
        // console.log("")

        let time0_new_key = time0_new.split("@")[0]
        let time0_new_time = "0-"+_text0.length
        let time0_new2 = time0_new_key+"@"+time0_new_time
        // console.log("time0_new2: ", time0_new2)

        // time info of deleted_block
        let deleted_block_old_data = {}
        let deleted_block_old_length = -1
        if (deleted_block) {
          deleted_block_old_data = deleted_block.getData().toObject()
          deleted_block_old_length = deleted_block.getLength()
        }
        // let block_old_data = block_old.getData().toObject()
        // let block_old_length = block_old.getLength()
        let deleted_time0_old = ""
        if ( deleted_block_old_data["time0"] ) {
          deleted_time0_old = deleted_block_old_data["time0"]
        }
        // console.log("deleted_time0_old: ", deleted_time0_old)

        let deleted_time0_old_key = deleted_time0_old.split("@")[0]
        let deleted_time0_old_time = _text0.length+"-"+_text1.length
        let deleted_time0_old2 = deleted_time0_old_key+"@"+deleted_time0_old_time
        // console.log("deleted_time0_old2: ", deleted_time0_old2)

        let front_row_deleted = false

        // data of block content
        let _bk = null
        if (_entireTextsAreDeleted(content_new_raw.blocks) === true) {
          _bk = {
            'time0': "dummy@0-0"
          }
        } else {
          // もし、セレクトして纏めて下の行が削除された場合
          //
          // console.log("block_text_new count: ", block_text_new.length, block_text_new)
          // console.log("_text0 count: ", _text0.length, _text0)

          if (block_text_new.length === _text0.length) {

            let _arr00 = time0_new2.split("___")
            let time0_new_new_00 = ""
            for (let j=0; j<_arr00.length; j++) {
              let _itme00 = _arr00[j]

              if (j !== _arr00.length -1){

                time0_new_new_00 = time0_new_new_00 + _itme00

              } else {

                let _key000 = _itme00.split("@")[0]
                let _start000 = parseFloat(_key000.split("~")[0])

                let _end001 =  parseFloat(deleted_time0_old_key.split("~")[1])
                let _range000 = _itme00.split("@")[1]

                let _itme01 = _start000+"~"+_end001+"@"+_range000

                time0_new_new_00 = time0_new_new_00 + _itme01
              }
            }

            // console.log(">>>>>>>>>>>>>>")
            // console.log("time0_new_new_00: ", time0_new_new_00)
            // console.log("<<<<<<<<<<<<<")

            _bk = {
              'time0': time0_new_new_00
            }



          } else if ( deleted_text.indexOf(block_text_new) !== -1 ) {
            // 上の行が消された

            // console.log("???? --- ???")

            //
            let _arr00 = deleted_time0_old2.split("___")
            let time0_new_new_00 = ""

            // // calculate length of 1-end
            // for (let j=0; j<_arr00.length; j++) {
            //   let _itme00 = _arr00[j]
            //   let _str004 = _itme00.split("@")[1]
            //   let _str004 = _itme00.split("@")[1]
            //
            // }

            for (let j=0; j<_arr00.length; j++) {

              let _itme00 = _arr00[j]
              // console.log("_itme00: ", _itme00)

              let _str4 = _itme00.split("@")[0]
              let _end4 = parseFloat(_str4.split("~")[1])

              let _str5 = _itme00.split("@")[1]
              let _offset5 = _str5.split("-")[0]
              let _length5 = _str5.split("-")[1]
              // console.log("_str5: ", _str5)

              if (j === 0){

                let _arr5 = time0_new2.split("___")
                let _timestr5 = _arr5[_arr5.length-1]
                let _timekey5 = _timestr5.split("@")[0]
                let _start4 = parseFloat(_timekey5.split("~")[0])
                // let _end4 = parseFloat(_timekey5.split("~")[1])
                // let _range000 = _timestr5.split("~")[1]
                // console.log("_timekey5: ", _timekey5)
                // console.log("_range000: ", _range000)

                let _itme01 = _start4+"~"+_end4+"@"+_str5

                // console.log("????????????????")
                // console.log("_itme01: ", _itme01)

                time0_new_new_00 = time0_new_new_00 + _itme01

                // console.log("time0_new_new_00: ", time0_new_new_00)
                // console.log("????????????????")

                front_row_deleted  = true

              } else {
                time0_new_new_00 = time0_new_new_00 + _itme00
              }
            }

            _bk = {
              'time0': time0_new_new_00
            }

          } else {

            _bk = {
              'time0': time0_new2+"___"+deleted_time0_old2
            }
          }
        }


        let selection_satete = newState.getSelection()

        let updated_selection_state = null
        if (front_row_deleted === true) {
          updated_selection_state = selection_satete.merge({
            focusOffset: 0,
            anchorOffset: 0,
          });
        } else {
          updated_selection_state = selection_satete.merge({
            focusOffset: _text0.length,
            anchorOffset: _text0.length,
          });
        }
        // var updated_selection_state = selection_satete.merge({
        //   focusOffset: _text0.length,
        //   anchorOffset: _text0.length,
        // });

        let content_state4 = Modifier.setBlockData(
          content_new,
          updated_selection_state,
          _bk,
        )

        let new_editor_state_5 = EditorState.push(
          newState,
          content_state4,
          'add-data' // サンプルをコピーしたが、 EditorChangeType に従ってないからダメなのかも
        )
        // setEditorState(newState3)
        setEditorState(EditorState.forceSelection(new_editor_state_5, updated_selection_state))

        return

      } else if (content_old_raw.blocks.length !== content_new_raw.blocks.length) {

        // console.log("koko ??? 3 ")
        //
        // console.log("error!!!", content_old_raw.blocks.length, content_new_raw.blocks.length)
        // // props.showAlert('申し訳ありません。いっぺんにいっぱい消しすぎです')
        return;
      }

      if (block_new_length !== block_old_length) {

        // console.log("koko ??? 1 ")
        // console.log("block_new_length: ", block_new_length)
        // console.log("block_old_length: ", block_old_length)
        // console.log("======= text modified =======")

        // length of word to change
        let length_changed = block_new_length - block_old_length

        if (anchor_offset_old === 0 && anchor_offset_new !== 0) {
          // ひらがなはanchor_offset_oldが取れない
          anchor_offset_old = anchor_offset_new - length_changed
        }

        // text comparison
        let old_content_state = editorState.getCurrentContent()
        let old_content_block = old_content_state.getBlockForKey(block_key_new)
        let _text_old = ""
        if (old_content_block) {
          _text_old = old_content_block.getText()
        }

        let _text_new =  block_new.getText()

        if (time0_new) {

          // loop for all time data
          let arr0 = time0_new.split("___")

          let time0_new_2 = ""
          for (let i=0; i<arr0.length; i++) {

            let _timedata = arr0[i]

            let _time_key_last = _timedata.split("@")[0]
            let _offsets_last = _timedata.split("@")[1]
            let _start = parseInt(_offsets_last.split("-")[0])
            // let _end = parseInt(_offsets_last.split("-")[1])
            let _length = parseInt(_offsets_last.split("-")[1])
            let _end = _start + _length

            // if index of deleted word was in this timedata item,
            // then chnge end...

            if (anchor_offset_old <= _end) {

              // if (anchor_offset_old > _start) {
              if (anchor_offset_old >= _start) {
                //    3
                // 0------(10)
                // 0----(7)

                // console.log("--- 3.0 ---", _time_key_last)

                let block_new_text = block_new.text
                let block_old_text = ""
                if (block_old) {
                  block_old_text = block_old.text
                }

                let _length_2 = _length + length_changed
                let _start_2 = _start

                let _timedata_edit = _time_key_last+"@"+_start_2+"-"+_length_2

                // check if entire texts are deleted
                if (_entireTextsAreDeleted(content_new_raw.blocks) === true){
                  time0_new_2 = "dummy@0-0"
                } else {
                  time0_new_2 = time0_new_2 + _timedata_edit + "___"
                }

              } else {
                //    3
                //         10-------(10)
                //         7(10)

                // console.log("--- 3.1 --- ", _time_key_last)
                // console.log("行を削除した時に通過する")


                // let _length_2 = _length + length_changed
                let _length_2 = _length

                let _start_2 = _start + length_changed
                // let _start_2 = _start

                // let _timedata_edit = _time_key_last+"@"+_start_2+"-"+_length_2

                let _timedata_edit = _time_key_last+"@"+_start_2+"-"+_length_2


                time0_new_2 = time0_new_2 + _timedata_edit + "___"

              }

            } else {
              //             13
              // 0------(10)

              // console.log("--- 3.2 ---", _time_key_last)

              let _length_2 = _length
              let _start_2 = _start

              let _timedata_edit = _time_key_last+"@"+_start_2+"-"+_length_2

              if (_length_2 > 0) {
                time0_new_2 = time0_new_2 + _timedata_edit + "___"
              }
            }
          }

          if (time0_new_2.endsWith("___") === true) {
            time0_new_2 = time0_new_2.substr(0, time0_new_2.length-3)
          }

          let _bk = {
            'time0': time0_new_2
          }

          // update newly combined block
          // let selection_state3 = SelectionState.createEmpty(block_key_new)

          let selection_satete = newState.getSelection()

          let content_state4 = Modifier.setBlockData(
            content_new,
            selection_satete,
            _bk,
          )

          let editor_state4 = EditorState.push(
            newState,
            content_state4,
            'add-data' // サンプルをコピーしたが、 EditorChangeType に従ってないからダメなのかも
          )
          setEditorState(editor_state4)

          return

        } else {
          // console.log("dfsaf time0 is missing...")
        }

      } else {

        // console.log("koko ??? 2 ")
        // // reset removed_and_added
        // setRemoved("")
        // setAdded
        // console.log("selecte and delete ")
      }
    }


    setEditorState(newState)

    // // https://gist.github.com/scf4/bb49f9167d1c24357d5ee0a8bbb777de
    // let currentContent = newState.getCurrentContent();
    // let firstBlockKey = currentContent.getBlockMap().first().getKey();
    //
    // let currentBlockKey = newState.getSelection().getAnchorKey();
    // let isFirstBlock = (currentBlockKey === firstBlockKey);
    // let currentBlockType = RichUtils.getCurrentBlockType(newState);
    // let isHeading = currentBlockType === "header-one";
    //
    // if (isFirstBlock !== isHeading) {
    //   setEditorState(RichUtils.toggleBlockType(newState, "header-one"))
    // } else {
    //   setEditorState(newState)
    // }

  }

  // _keyBindingFn
  let _keyBindingFn = (e) => {

    let isCommandModifed = KeyBindingUtil.hasCommandModifier(e)

    if (isCommandModifed === false ) {
      // 189 -> 32

      // console.log("e.keyCode: ", e.keyCode)

      // if (e.keyCode === 13) {
      //   setShowTooltip(false)
      // }

      if (lastKey1 === 189 && e.keyCode === 32) {

        let currentBlockType = RichUtils.getCurrentBlockType(editorState);
        if (currentBlockType === "unstyled") {

          // setEditorState(RichUtils.toggleBlockType(editorState, "unordered-list-item"))

          let contentState =  editorState.getCurrentContent()

          let selectionState = editorState.getSelection()

          let _contentState = Modifier.replaceText(
              contentState,
              selectionState.merge( {
                  // The starting position of the range to be replaced.
                  anchorOffset: 0,
                  // The end position of the range to be replaced.
                  focusOffset: selectionState.getEndOffset()
              } ),
              "",
          )

          let editorState_new = EditorState.push(
                          editorState,
                          _contentState,
                          'replace-text',
                      )

          setEditorState(RichUtils.toggleBlockType(editorState_new, "unordered-list-item"))
        }

      }

      setLastKey1(e.keyCode)
    }
  }

  // // _handleMouseUp
  // let _onMouseUp = () => {
  //
  //   function getSelected() {
  //      var t = '';
  //      if (window.getSelection) {
  //         t = window.getSelection();
  //      } else if (document.getSelection) {
  //         t = document.getSelection();
  //      } else if (document.selection) {
  //         t = document.selection.createRange().text;
  //      }
  //      return t;
  //   }
  //
  //   setTimeout(()=> {
  //
  //     let selected = getSelected();
  //
  //     if (!selected || !selected.anchorNode) {
  //       setShowTooltip(false)
  //
  //       return;
  //     }
  //
  //     let rect = selected.getRangeAt(0).getBoundingClientRect();
  //
  //     if (rect.width < 1) {
  //
  //       setShowTooltip(false)
  //
  //     } else {
  //
  //
  //       if (isMobile === true) {
  //         setLeft(10)
  //         setTop(rect.top - 100)
  //         // setTop(rect.top - 400)
  //       } else {
  //         setLeft(rect.left + 3)
  //         // setTop(rect.top - 65)
  //         setTop(rect.top - 135)
  //       }
  //
  //       setShowTooltip(true)
  //     }
  //
  //   }, 1)
  // }

  // get text remain
  let _diff_remain_parts = (text_new, text_orig) => {

    let _diff0 = Diff.diffChars(text_new, text_orig)

    let _remains1 = ""
    let _end_detected1 = false
    for ( let i=0; i<_diff0.length; i++ ) {

      if (!_diff0[i].added && !_diff0[i].removed) {
        if (_end_detected1 === false) {
          _remains1 = _remains1 + _diff0[i].value
        }
      } else {
        _end_detected1 = true
      }
    }

    if ( text_orig.indexOf(_remains1) === -1 ) {
      _remains1 = ""
    }
    // console.log("11 _remains1: ", _remains1)

    if (_remains1) {
      return _remains1
    }

    // reverse
    // let _remains2 = ""
    let _end_detected2 = false
    for ( let i=_diff0.length-1; i>0; i-- ) {

      if (!_diff0[i].added && !_diff0[i].removed) {
        if (_end_detected2 === false) {
          _remains1 = _diff0[i].value + _remains1
        }
      } else {
        _end_detected2 = true
      }
    }

    // console.log("22 _remains1: ", _remains1)

    if ( text_orig.indexOf(_remains1) === -1 ) {
      _remains1 = ""
    }

    return _remains1
  }


  let _entireTextsAreDeleted = (blocks) => {

    let _texts_all = ""
    for ( let i=0; i<blocks.length; i++ ) {
      let _block = blocks[i]
      let _text = _block.text
      _texts_all = _texts_all + _text
    }
    // _texts_all = _texts_all.trim()

    if (!_texts_all) {
      return true
    } else {
      return false
    }
  }

  // // submit btn
  // let _submitPost = () => {
  //
  //   let contentState = editorState.getCurrentContent()
  //   let contentStateRaw = convertToRaw(contentState)
  //   let contentStateRawStringified = JSON.stringify(contentStateRaw)
  //
  //   // get texts
  //   let blocks = contentStateRaw.blocks;
  //   let _transcript = blocks.map(block => (!block.text.trim() && '\n') || block.text).join(' ');
  //
  //   props.submitPost({
  //     healthScore: healthScore,
  //     contentStateRawStringified: contentStateRawStringified,
  //     transcript_upd: _transcript,
  //   })
  // }

  // test
  let _test = () => {

    let rawData = convertToRaw(editorState.getCurrentContent())
    console.log("rawData: ", rawData)
    console.log("")
  }

  // _handlePastedText
  let _handlePastedText = () => {
    return "handled"
  }

  // make selection ok
  let _makeSelectionOk = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_OK'))
  }

  // make selection ok
  let _makeSelectionNotOk = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_NOT_OK'))
  }

  // make selection dictonary
  let _makeSelectionDict = () => {
    setEditorState(RichUtils.toggleInlineStyle(editorState, 'HIGHLIGHT_DICT'))
  }


  // make selection Head
  let _makeSelectionH = () => {
    setEditorState(RichUtils.toggleBlockType(editorState, "header-two"));
  }


  let _hiraganaChanged = (e) => {
    setHiragana(e.target.value)
  }

  // _wordCategoryChanged
  let _wordCategoryChanged = (e) => {
    setWordCategory(e.target.value)
  }

  let _addOneVocab2Dict = async (e) => {

    if (!hiragana) {
      return
    }

    let _content_state = editorState.getCurrentContent()
    let _selection_state = editorState.getSelection()
    let _anchor_key = _selection_state.getAnchorKey()
    let _current_block = _content_state.getBlockForKey(_anchor_key);

    let _start_offset = _selection_state.getStartOffset()
    let _end_offset = _selection_state.getEndOffset()

    let _texts = _current_block.getText()

    let kanji = _texts.substr(_start_offset, (_end_offset-_start_offset))

    if (!kanji) {
      return
    }

    await props.addOneVocab2Dict({
      kanji: kanji,
      kana: hiragana,
      wordCategory: wordCategory,
    })

    // setShowTooltip(false)
    setHiragana("")
    setWordCategory("")
    // setKanji("")
  }


  // editor clicked > _editorMouseover
  let _editorMouseover = (e) => {

    let rect = e.target.getBoundingClientRect();

    if (e.target.className.indexOf("col-12") !== -1 ) {
      return;
    }
    if (e.target.className.indexOf("DraftEditor") !== -1 ) {
      return;
    }

    let _texs = ""
    if (e.target.innerText) {
      _texs = e.target.innerText
    }

    props.setYPos({
      texts: _texs,
      relativeY: rect.top,
    })
  }


  // // test
  // let _tooltipclicked = (e) => {
  //   console.log("_tooltipclicked")
  //   e.preventDefault()
  // }

  // convert draft js into highlighted
  let _gotoWordCheckMode = async () => {
    // console.log("_gotoWordCheckMode: ")

    // current
    let current_content_state = editorState.getCurrentContent()
    let current_content_json = convertToRaw(editorState.getCurrentContent())
    let current_texts = ""
    for ( let i=0; i<current_content_json.blocks.length; i++ ) {
      let _block = current_content_json.blocks[i]
      let _text = _block.text
      current_texts = current_texts + _text + " "
    }
    current_texts = current_texts.trim()
    // console.log("current_texts: ", current_texts)

    // original
    let original_texts = ""
    for ( let i=0; i<props.transcriptDraftjsRaw.blocks.length; i++ ) {
      let _block = props.transcriptDraftjsRaw.blocks[i]
      let _text = _block.text
      original_texts = original_texts + _text + " "
    }
    original_texts = original_texts.trim()
    // console.log("original_texts: ", original_texts)

    if (current_texts === original_texts) {
      // console.log("contents are same.")

      props.showAlert("コンテンツは編集されていません", "info")

      return;
    }

    // switch mode
    setDemoMode("word_check")

    // current draftjs
    let current_draftjs = convertToRaw(editorState.getCurrentContent())
    if (!current_draftjs) {
      return;
    }

    let draftjs_fixed = {}
    let fixed_obj1 = {}
    let last_start1 = 0
    // if (_item && _item.draftjs_raw_serialied) {
    if (current_draftjs) {

      draftjs_fixed = current_draftjs
      // console.log("draftjs_fixed: ", draftjs_fixed)

      let _blocks = draftjs_fixed.blocks

      for (let i=0; i<_blocks.length; i++) {
        let _block = _blocks[i]

        let _texts = _block.text
        // sentence_fixed = sentence_fixed + _texts

        let _time0 = ""
        if (_block.data && _block.data.time0) {
          _time0 = _block.data.time0
        }
        if (_time0) {
          let _arr1 = _time0.split("___")
          for ( let j=0; j<_arr1.length; j++ ) {

            let _str1 = _arr1[j]
            let _arr2 = _str1.split("@")
            let _time_key = _arr2[0]
            let _start = parseFloat(_time_key.split("~")[0])
            let _end = parseFloat(_time_key.split("~")[1])
            let _range = _arr2[1]
            let _range0 = parseInt(_range.split("-")[0])
            let _range1 = parseInt(_range.split("-")[1])

            if (_start <= last_start1) {
              // console.log("_start < last_start1 ?")
              // console.log("WFT? ", _start, last_start1 )
              // console.log("")
              continue
            }

            if ( !fixed_obj1[_time_key] ) {
              fixed_obj1[_time_key] = {
                start: _start,
                end: _end,
                texts: _texts.substr(_range0, _range1)
              }
            } else {
              fixed_obj1[_time_key].texts = fixed_obj1[_time_key].texts + _texts.substr(_range0, _range1)
            }

            last_start1 = _start
          }
        }
      }
      // console.log("fixed_obj1: ", fixed_obj1)

      // sentence_fixed = sentence_fixed.trim()
      // console.log("sentence_fixed: ", sentence_fixed)

      // // get wakachi
      // let processed_text1 = await _getWakachi(sentence_fixed)
      // console.log("processed_text1: ", processed_text1)
      // setProcessedText1(processed_text1)
    }

    // let sentence_ai = ""
    // let default_list1 = []
    let default_obj1 = []
    let last_start2 = 0
    // if (_item && _item.draftjs_raw_by_ai) {
    if (props.transcriptDraftjsRaw) {

      // console.log("_item.draftjs_raw_by_ai: ", _item.draftjs_raw_by_ai)

      let draftjs_ai = props.transcriptDraftjsRaw
      // console.log("draftjs_ai: ", draftjs_ai)

      let _blocks = draftjs_ai.blocks

      for (let i=0; i<_blocks.length; i++) {
        let _block = _blocks[i]

        let _texts = _block.text
        // sentence_ai = sentence_ai + _texts

        let _time0 = ""
        if (_block.data && _block.data.time0) {
          _time0 = _block.data.time0
        }
        if (_time0) {
          let _arr1 = _time0.split("___")
          for ( let j=0; j<_arr1.length; j++ ) {

            let _str1 = _arr1[j]
            let _arr2 = _str1.split("@")
            let _time_key = _arr2[0]
            let _start = parseFloat(_time_key.split("~")[0])
            let _end = parseFloat(_time_key.split("~")[1])
            let _range = _arr2[1]
            let _range0 = parseInt(_range.split("-")[0])
            let _range1 = parseInt(_range.split("-")[1])

            if (_start < last_start2) {
              console.log("_start < last_start2")
              // console.log("WFT? ", _start, last_start2 )
              // console.log("")
              continue
            }


            if ( !default_obj1[_time_key] ) {
              default_obj1[_time_key] = {
                start: _start,
                end: _end,
                texts: _texts.substr(_range0, _range1)
              }
            } else {
              default_obj1[_time_key].texts = default_obj1[_time_key].texts + _texts.substr(_range0, _range1)
            }

            // default_list1.push({
            //   key: _time_key,
            //   start: _start,
            //   end: _end,
            //   texts: _texts.substr(_range0, _range1)
            // })

            last_start2 = _start
          }
        }
      }
      // console.log("fixed_obj1: ", fixed_obj1)

      // sentence_ai = sentence_ai.trim()
      // console.log("sentence_ai: ", sentence_ai)

      // // get wakachi
      // let processed_text2 = await _getWakachi(sentence_ai)
      // console.log("processed_text2: ", processed_text2)
      // setProcessedText2(processed_text2)
    }

    let missed_obj1 = {}

    // fixed_obj1
    for ( let key in fixed_obj1 ) {

      let _item_fixed = fixed_obj1[key]
      let _texts_fixed = _item_fixed.texts

      // let _item_default = null
      let _texts_default = ""
      if ( default_obj1[key] ) {
        let _item_default = default_obj1[key]
        _texts_default = _item_default.texts
      }

      // diff

      let _diffs = Diff.diffChars(_texts_fixed, _texts_default)

      // console.log("_texts_fixed  : ", _texts_fixed)
      // console.log("_texts_default: ", _texts_default)

      for ( let i=0; i<_diffs.length; i++ ) {
        let _item2 = _diffs[i]
        if (_item2.removed === true) {
          // console.log("_item2: ", _item2.value)

          if (!missed_obj1[key]) {
            missed_obj1[key] = []
          }
          missed_obj1[key].push(_item2.value)
        }
      }
      // console.log("")
    }

    // console.log("")
    // console.log("missed_obj1: ", missed_obj1)
    // console.log("")

    // list of fixed draftjs blocks objects
    let fixed_list1 = []
    for ( let key in fixed_obj1 ) {

      let _item = fixed_obj1[key]
      // console.log("_item: ", _item)

      fixed_list1.push({
        key: key,
        start: _item.start,
        end: _item.end,
        texts: _item.texts,
      })
    }

    // get trimmed_words
    let trimmed_words = await props.checkWord(missed_obj1, fixed_list1)

    // prepare fixed_obj2
    for ( let i=0; i<fixed_list1.length; i++ ) {

      let _item = fixed_list1[i]
      let _texts = _item.texts
      let _key = _item.key

      // console.log("")
      // console.log("_texts: ", _texts)
      if ( trimmed_words[_key] ) {
        // console.log("trimmed_words.key: ", trimmed_words[_key])
        for (let j=0; j<trimmed_words[_key].length; j++) {

          let _word = trimmed_words[_key][j]

          let _results = _texts.match(_word)
          if (_results) {
            // console.log("index: ", _results.index)

            if (!fixed_list1[i].inlineStyleRanges) {
              fixed_list1[i].inlineStyleRanges = []
            }

            // add
            fixed_list1[i].inlineStyleRanges.push({
              length: _word.length,
              offset: _results.index,
              style: 'HIGHLIGHT_DICT',
            })
          }
        }

      }
      // console.log("")
    }

    // console.log("")
    // console.log("draftjs_fixed: ", draftjs_fixed)
    // console.log("fixed_list1: ", fixed_list1)
    // console.log("")

    draftjs_fixed.blocks = fixed_list1

    let draftjs_for_dict = {
      'blocks': [],
      'entityMap': {},
    }

    for (let i=0; i<fixed_list1.length; i++) {

      let _item = fixed_list1[i]
      let _key = _item.key
      let _texts = _item.texts
      let _start = _item.start
      let _end = _item.end
      let _inlineStyleRanges = _item.inlineStyleRanges

      // console.log("_texts: ", _texts)

      draftjs_for_dict.blocks.push({
        'data': {
          time0: _start+"~"+_end+"@0-"+_texts.length,
        },
        'entityRanges': [],
        'inlineStyleRanges': _inlineStyleRanges,
        'key': Math.random().toString(16).slice(2),
        'text': _texts,
        'type': 'unstyled',
      })
    }

    // setDraftjsJson(draftjs_for_dict)

    let state1 = convertFromRaw(draftjs_for_dict);
    setEditorState(EditorState.createWithContent(state1))

    // console.log("draftjs_for_dict: ", draftjs_for_dict)
  }


  // create custom dictonary
  let _createDictionary = async() => {

    let draftjs = convertToRaw(editorState.getCurrentContent())
    props.addVocabsToCustomDictonary(draftjs)

    setDemoMode("edit")
  }


  return (
    <div>

      {/* editor */}
      <Row style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <Col md="12" xs="12" onMouseOver={_editorMouseover}>
          <Editor
            plugins={plugins}
            editorState={editorState}
            keyBindingFn={_keyBindingFn}
            handleKeyCommand={_handleKeyCommand}
            handlePastedText={_handlePastedText}
            onChange={_onChange} />
        </Col>
      </Row>

      <Row style={{
        marginTop: 20,
        marginBottom: 60,
      }}>
        <Col md="12" xs="12">

          {demoMode === "edit" && (
            <Button
              onClick={_gotoWordCheckMode}
              color="primary"
              style={{
                cursor: 'pointer',
                width: '100%',
              }}>
              単語を抽出
            </Button>
          )}

          {demoMode === "word_check" && (
            <Button
              onClick={_createDictionary}
              color="success"
              style={{
                cursor: 'pointer',
                width: '100%',
              }}>
              辞書作成
            </Button>
          )}


        </Col>
      </Row>

    </div>
  )
})

export default DemoEditor
